// extracted by mini-css-extract-plugin
module.exports = {"actions-footer-wrapper":"ActionsFooter_actions-footer-wrapper__3e80o"};